import { css, cx, etiColors } from '@eti/styles';
import { ReactComponent as ToiletIcon } from '@eti/assets/icons/c_flat-toilet.svg';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const styles = css`
  rect {
    fill: ${etiColors.grayScale[10]};
  }
`;
const Toilet = () => /*#__PURE__*/_jsx(ToiletIcon, {
  className: cx(styles, rowItemSize)
});
export default Toilet;
//# sourceMappingURL=Toilet.js.map